import { RelatedService, RelatedServicesStore } from './related-services-types';

/**
 * Возвращает данные об актуальных измерениях
 * @param {RelatedServicesStore} relatedServices
 * @returns {RelatedService | undefined}
 */
export const selectActualMeasure = (relatedServices: RelatedServicesStore) =>
  selectActiveServices(relatedServices)?.find(
    ({ serviceKey }: RelatedService) => serviceKey === 'measurement'
  );

/**
 * Возвращает доступные услуги
 * @param {RelatedServicesStore} relatedServices
 * @returns {RelatedService[] | undefined}
 */
export const selectActiveServices = (relatedServices: RelatedServicesStore) =>
  relatedServices.serviceList?.filter(({ isAvailable }: RelatedService) => isAvailable);
